import { requireService, wrap } from '@repo/di-ez';
import type { GridApi, GridColDef } from '@repo/go-table';
import { Drawer, RadioButtonGroup } from '@repo/go-ui';
import type { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { TrajectoryGraphSettings } from '../trajectory-graph-settings';
import { TrajectoryTableSettings } from '../trajectory-table-settings';

import styles from './trajectory-settings-sidebar.module.scss';

type Props = {
  columns: GridColDef[];
  tableApi: MutableRefObject<GridApi>;
};

export const TrajectorySettingsSidebar = wrap<Props>(function TrajectorySettingsSidebar({ columns, tableApi }) {
  const { t } = useTranslation();
  const uiStore = requireService('trajectoryUiStore');
  const displayManager = uiStore.displayManager;

  return (
    <Drawer
      open={uiStore.isTableSettingsOpen}
      onClose={() => uiStore.setTableSettingsOpen(false)}
      style={{ width: 360 }}
      title={t('Toolbar.settings')}
      container={uiStore.settingsDrawerContainer ?? undefined}
      className={styles.drawer}
    >
      <div className={styles.tabs}>
        <RadioButtonGroup<'charts' | 'table' | 'trajectory'>
          className={styles.tabsSwitcher}
          size="m"
          value={uiStore.activeSettingsTab}
          onChange={(value) => {
            if (value === 'charts' || value === 'table') {
              uiStore.setActiveSettingsTab(value);
            }
          }}
          items={[
            { value: 'trajectory', label: t('Settings.tabs.trajectory'), disabled: true },
            { value: 'charts', label: t('Settings.tabs.charts') },
            { value: 'table', label: t('Settings.tabs.table') },
          ]}
        />
      </div>
      <div className={styles.content}>
        {uiStore.activeSettingsTab === 'charts' ? (
          <TrajectoryGraphSettings />
        ) : (
          <TrajectoryTableSettings tableApi={tableApi} displayManager={displayManager} columns={columns} />
        )}
      </div>
    </Drawer>
  );
});
